export default "__VITE_ASSET__D1jV26kW__"